module.exports = __webpack_public_path__ + "media/images/logo-inverse-b2c3b090a01ed60a960f727d5d386b0e.png";